(() => {
	angular
		.module('main')
		.directive(
			'addAppointmentWithoutScheduleModal',
			addAppointmentWithoutScheduleModal
		);

	addAppointmentWithoutScheduleModal.$inject = [
		'workflowService',
		'messageService',
		'validationService'
	];

	function addAppointmentWithoutScheduleModal(
		workflowService,
		messageService,
		validationService
	) {
		return {
			restrict: 'E',
			scope: {
				appointment: '<',
				taskList: '='
			},
			template: `<section>
                        <div id="appointmentWithoutScheduleModal" class="modal modal-center fade modal-appointment-lx" data-backdrop="static"
                             data-keyboard="false">
                            <div class="modal-dialog modal-dialog-datepicker">
                                <form ng-submit="saveAppointment(appointment, taskList, appointment.id)">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <btn-close></btn-close>
                                            <h3 class="modal-title">{{appointment.id ? 'Edit appointment':'Add appointment'}}</h3>
                                        </div>
                                        <div class="modal-body f-s-14-i" style="padding-bottom: 15px !important">
                                            <h3 class="mt-0 mb-25">Appointment details</h3>
                                            <div class="flex-row flex-wrap-xs flex-align-center mb-30">
                                                <div class="pr-30">
                                                    <p>Name</p>
                                                </div>
                                                <div class="flex-grow-1 flex-with-full mb-10">
                                                    <input type="text" class="form-control" name="appointmentName" ng-model="appointment.name" autocomplete="off"
                                                           required>
                                                </div>
                                            </div>
                                            <div class="flex-row">
                                                <p>
                                                   Update appointment schedule, including date range, time range and location, from within your job profile, once you have applied this workflow to a job.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"
                                                    spinning-wheel is-spinning-wheel-active="isUpdateSpinnningWheelActive">Save appointment
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
             `,
			replace: true,
			transclude: true,
			link(scope) {
				const appointmentModal = '#appointmentWithoutScheduleModal';

				$(appointmentModal)
					.on('show.bs.modal', () => {
						scope.taskInfo = workflowService.getTaskInfo();
						scope.isForEdit = scope.taskInfo.isForEdit;
						scope.appointment = angular.copy(scope.taskInfo.task);
						scope.$evalAsync();
					})
					.on('shown.bs.modal', function() {
						$(this)
							.find('input')
							.first()
							.focus();
						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});

				scope.saveAppointment = (appointment, taskTypes, id) => {
					scope.button_disable = true;

					const isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(appointment)) {
						scope.button_disabled = false;
						return;
					}

					if (!appointment.eventType) {
						appointment.eventType = 'APPOINTMENT';
					}

					scope.taskList = workflowService.pasteNewTaskInList(
						taskTypes,
						appointment
					); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(appointmentModal).modal('hide');
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addAppointmentWithoutScheduleModal.js